module.exports = new __parcel__URL__("ride_2.1e254981.mp3").toString();